export default __webpack_public_path__ + "static/media/interview_green.934c118a.svg";